import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../auth.service';
import { Subscription } from 'rxjs/Subscription';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NavbarComponent implements OnDestroy {

  constructor(public _authService: AuthService, private _router : Router, private titlePage : Title) {

   }

   setTytle(title: string){
     this.titlePage.setTitle(title);
   }

  ngOnDestroy() {

  }
  public logout() {
    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
        let token = this._authService.getAccesToken();
        let getUserLogin = this._authService.getAuthenticatedUser();
        if(token == undefined || token == null || getUserLogin == null || getUserLogin == undefined) {
          window.location.reload();
          window.localStorage.clear();
          this._router.navigate(['/login']); // If you are using router
        }
      }
    }, false);
    this._authService.logout();
  }

}



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.component.ts